module.exports = __webpack_public_path__ + "static/media/btn_apple_ptb.52239a65.png";